import { selectActiveServiceId, selectServices } from '../../reducers/v2/promotion/selectors';
import { createSelector } from 'reselect';
import { IAppState } from '../../../AppModulesWrapper';

export const selectActiveServiceIndex = createSelector(
  [(state: IAppState) => selectActiveServiceId(state), (state: IAppState) => selectServices(state)],
  (selectedServiceId, services) => {
    if (!selectedServiceId) {
      return undefined;
    }

    return services.findIndex(service => service.type === selectedServiceId);
  },
);
